export const checkTargetType = ({ clientTypes, value }) => {
  // @value === clientType selected
  if (clientTypes.length) {
    const currentTarget = clientTypes.find((ct) => ct.value === value);
    if (currentTarget) {
      return currentTarget.targetTypeCategory;
    } else {
      return null;
    }
  }
};

export function validateComment(comment) {
  if (!comment || typeof comment !== "string") {
    return false;
  }
  const tempComment = comment.trim();
  if (
    tempComment !== "" &&
    tempComment != null &&
    tempComment.length >= 15 &&
    tempComment.length <= 200
  ) {
    return true;
  } else {
    return false;
  }
}

export const DATE_WITH_MIN_YEAR = new Date().setFullYear("2015");

export const DATE_WITH_MIN_BIRTH_YEAR = new Date().setFullYear("1914");

export const DATE_WITH_CURRENT_YEAR = new Date().getTime();



// WEBPACK FOOTER //
// ./src/utilities/common.js